export default "__VITE_ASSET__91bfd57a__"